export interface ChangeColumnLabels {
  trigger: string
  reset: string
}

export const DEFAULT_CHANGE_COLUMN_LABELS: ChangeColumnLabels = {
  trigger: 'Change column order',
  reset: 'Reset to default',
}
